import { useNavigate } from "react-router-dom";
import { TradesmanProfileSetup } from "@/components/TradesmanProfileSetup";
import { SEO } from "@/components/SEO";

export function TradesmanProfileSetupPage() {
  const navigate = useNavigate();

  const handleProfileComplete = () => {
    navigate('/tradesman-registration-success');
  };

  return (
    <>
      <SEO 
        title="Complete Your Tradesman Profile - Sortable"
        description="Complete your tradesman profile setup by adding business information, uploading portfolio photos, and verifying your insurance documentation."
        keywords="tradesman profile, business setup, portfolio upload, insurance verification"
      />
      <div className="min-h-screen bg-background">
        <TradesmanProfileSetup onComplete={handleProfileComplete} />
      </div>
    </>
  );
}